import { DOCS_FORM_NAMES } from "core/consts";
import type { PdfCreatorProps } from "../..";
import { FieldConfig, createDischargeLetterPdf } from "../pdfCreationUtils";

export const CARDIOLOGY_FIELD_CONFIG: Array<
  FieldConfig<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY>
> = [
  {
    key: "diagnoses",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.diagnoses,
  },
  {
    key: "therapy_and_course",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.therapyAndCourse,
  },
  {
    key: "anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.anamnesis,
  },
  {
    key: "social_anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.socialAnamnesis,
  },
  {
    key: "allergies",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.allergies,
  },
  {
    key: "physical_status",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.physicalStatus,
  },
  {
    key: "parameters",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.parameters,
  },
  {
    key: "lab_results",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.labResults,
  },
  {
    key: "ecg",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.ecg,
  },
  {
    key: "additional_diagnostic_findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .additionalDiagnosticFindings,
  },
  {
    key: "admission_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .admissionMedication,
  },
  {
    key: "discharge_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .dischargeMedications,
  },
  {
    key: "recommendations",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.recommendations,
  },
  {
    key: "appointments",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.appointments,
  },
  {
    key: "laboratory_parameters",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .laboratoryParameters,
  },
];

export function createCardiologyDischargeLetterPdf(
  props: PdfCreatorProps<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY>,
) {
  return createDischargeLetterPdf<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY
  >(props, CARDIOLOGY_FIELD_CONFIG);
}
